"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redactObjectKeys = void 0;
var _fp = require("lodash/fp");
var mapValuesWithKey = _fp.mapValues.convert({
  cap: false
});

// This function emulates the redacted keys function from bugsnag.
var redactObjectKeys = function redactObjectKeys(redactedKeys) {
  var mapValueToRedacted = function mapValueToRedacted(value, key) {
    var shouldRedactKey = (0, _fp.some)(function (regex) {
      return regex.test(key);
    }, redactedKeys);
    if (shouldRedactKey) {
      return '[REDACTED]';
    }
    if ((0, _fp.isObject)(value)) {
      return redactObjectKeys(redactedKeys)(value);
    }
    return value;
  };
  return function (obj) {
    if (!(0, _fp.isObject)(obj)) {
      return obj;
    }
    if ((0, _fp.isArray)(obj)) {
      return (0, _fp.map)(mapValueToRedacted, obj);
    }
    return mapValuesWithKey(mapValueToRedacted)(obj);
  };
};
exports.redactObjectKeys = redactObjectKeys;